import React, { useMemo, useState } from 'react';
import { Box, Typography, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { ClusterReturnSeries, getClusterIds } from './calculation';
import { FeatureLineChart } from './components';
import { computeClusterFeatures } from './calculation';


type Props = {
    clustering: {
        id: string;
        name: string;
        series: string;
    };
    timeseries: any[];
    clusterReturnSeries: ClusterReturnSeries,
    clusterIds: number[];
    clusteringAssignment: string;
};

const ClusteringFeatureChart = ({
    clustering,
    timeseries,
    clusterReturnSeries,
    clusterIds,
    clusteringAssignment
}: Props) => {
    const clusterFeatureSeries = useMemo(
        () => computeClusterFeatures(timeseries, clusterIds, clusteringAssignment),
        [timeseries, clusterIds, clusteringAssignment]
    );

    if (!timeseries || timeseries.length === 0) {
        return (
            <Box display="flex" alignItems="center" justifyContent="center" height="400px">
                <Typography>No data available</Typography>
            </Box>
        );
    }

    return (
        <Box>
            <Typography variant="subtitle2" gutterBottom>
                Features – {clustering.name}
            </Typography>

            <FeatureLineChart
                featureSeries={clusterFeatureSeries}
                clusterReturnSeries={clusterReturnSeries}
                selectedClusters={clusterIds}
            />
        </Box>
    );
};

export default ClusteringFeatureChart;